class GismapApi {
    constructor (locator) {
        this._dg = locator.resolve('window').DG;
    }

    showMap () {
        let map;
        let _dg = this._dg;
        _dg.then(function () {
            map = _dg.map('map', {
                center: [54.980166, 82.898141],
                zoom: 16
            });

            _dg.marker([54.980166, 82.898141]).addTo(map).bindPopup(
                '<div style="color: #ffc84b; font: 22px/24px Arial,sans-serif;">2ГИС, городской информационный сервис</div>' +
                '<div style="margin-top: 10px; font: 16px/18px Arial,sans-serif;">Карла Маркса площадь, 7</div>');
        });
    }

    register () {
        const window = this._window;
        const document = this._window.document;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = this._config.analytics.yandex.url;

        const firstScriptNode = document.getElementsByTagName('script')[0];
        function bindScriptNode () {
            firstScriptNode.parentNode.insertBefore(script, firstScriptNode);
        }

        if (window.opera == '[object Opera]') {
            document.addEventListener('DOMContentLoaded', bindScriptNode, false);
        } else {
            bindScriptNode();
        }
    }
}

module.exports = GismapApi;



// WEBPACK FOOTER //
// ./services/gismap/api.js